export const toPercent = (
    value: number | null | undefined,
    sigFigs?: number
): string => {
    if (value == null || isNaN(value)) return "";

    const decimals = sigFigs ?? 0;

    return `${(value * 100).toFixed(decimals)}%`;
};